import React, {  useEffect, useState } from "react";
import UniversalTarjetaCurso from "../../../../components/UniversalTarjetaCurso";
import { getCategoriaData } from "../../../publico/Home/services/homeService";
import { getCursosEmpaginados } from "../../../publico/Cursos/services/cursosService";
import { useSearchParams } from "react-router-dom";
import SubFilter from "../../../publico/Cursos/components/SubFilterSearch/components/SubFilter";
import SubEmpaginador from "../../../publico/Cursos/components/SubEmpaginador";
import UniversalIconPerfil from "../../../../components/UniversalIconoPerfil/UniversalIconPerfil";
import UniversalBarraBusquedaCursos from "../../../../components/UniversalBarraBusquedaCursos/UniversalBarraBusquedaCursos";

export default function CursosNoComprados({scrollRef}) {
  let [searchParams] = useSearchParams();
  const [vCategorias, setVCategorias] = useState([]);
  const [vCursos, setVCursos] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalResultados, setTotalResultados] = useState(0);
  const [vCategoriesSelected, setVCategoriesSelected] = useState(
    searchParams.get("categoria_ids") ? [searchParams.get("categoria_ids")] : []
  );

  const [vIsScrollTop, setVIsScrollTop] = useState(true);
  const mGetCategoriasFetch = () => {
    getCategoriaData()
      .then((response) => {
        if (response.ok) {
          return response.json();
        }

        // Manejo de diferentes tipos de errores basados en el código de estado
        switch (response.status) {
          case 400:
            console.log("Datos inválidos");
            throw new Error("ERR_VALIDATION");

          case 401:
            console.log("Acceso denegado");
            throw new Error("ERR_UNAUTHORIZED");

          case 500:
            console.log("Error al obtener categorias");
            throw new Error("ERR_SERVER");

          default:
            console.log("Error inesperado");
            throw new Error("ERR_UNKNOWN");
        }
      })
      .then((result) => {
        if (result !== undefined) {
          switch (result["detail"]["acción"]) {
            case "CATEGORIAS_OBTENIDAS":
              setVCategorias(result["detail"]["datos"]);
              break;

            default:
              break;
          }
        }
      })
      .catch((error) => {
        // Separar las propiedades del error
        const { message } = error;
        if (message !== "ERR_ME") {
          console.log("Error de red");
        }
      });
  };
  const mGetCursosEmpaginadosFetch = () => {
    getCursosEmpaginados(page, pageSize, vCategoriesSelected)
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        // Manejo de errores según el status de la respuesta
        switch (response.status) {
          case 400:
            console.log("Datos inválidos");
            throw new Error("ERR_VALIDATION");
          case 401:
            console.log("Acceso denegado");
            throw new Error("ERR_UNAUTHORIZED");
          case 500:
            console.log("Error al obtener cursos");
            throw new Error("ERR_SERVER");
          default:
            console.log("Error inesperado");
            throw new Error("ERR_UNKNOWN");
        }
      })
      .then((result) => {
        if (result !== undefined && result.detail) {
          // Se espera que el endpoint devuelva "accion": "MOSTRAR_CURSOS"
          if (result.detail["acción"] === "MOSTRAR_CURSOS") {
            const datos = result.detail.datos;
            setVCursos(datos.cursos);
            setTotalPages(datos.paginas_totales);
            setTotalResultados(datos.total_resultados);
          }
        }
      })
      .catch((error) => {
        console.log("Error de red", error);
      });
  };
  useEffect(() => {
    const handleScroll = () => {
      scrollRef.current && scrollRef.current.scrollTop > 0
        ? setVIsScrollTop(false)
        : setVIsScrollTop(true);
    };

    const scrollElement = scrollRef.current;
    if (scrollElement) {
      scrollElement.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (scrollElement) {
        scrollElement.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);
  // Se vuelve a llamar al endpoint cada vez que cambia el estado "page"
  useEffect(() => {
    mGetCursosEmpaginadosFetch();
  }, [page, vCategoriesSelected]);
  useEffect(() => {
    mGetCategoriasFetch();
  }, []);
  useEffect(() => {
    setPage(1); // Reinicia la paginación si cambian las categorías
  }, [vCategoriesSelected]);

  const pageSize = 1;

  return (
    <div
      data-figma-id="238:10261"
      class="alumno-cursos-no-comprados"
      
    >
      <div
        data-figma-id="810:15668"
        class="header-style"
        style={{
          backgroundColor: vIsScrollTop ? "transparent" : "#1d1d1d",
        }}
      >
        <p data-figma-id="810:15669" class="header-texto">
          
        </p>
        <div data-figma-id="810:15670" class="header-iconos">
          <i class="fi fi-rs-bell bell-1-2"></i>
          <UniversalIconPerfil />
        </div>
      </div>
      <div data-figma-id="238:9857" class="cursos-header-alumno">
        <div data-figma-id="113:8881" class="home-barra-busqueda">
          <UniversalBarraBusquedaCursos vCategoriasObtenidas={vCategorias} />
        </div>
      </div>
      <div data-figma-id="238:9861" class="cursos-contenido-alumno">
        <div data-figma-id="238:9862" className="cursos-contenido-header">
          <div
            data-figma-id="238:9863"
            className="cursos-contenido-header-titulos-2"
          >
            <img
              src="images/book-alt-1.svg"
              data-figma-id="238:10251"
              className="img-30"
              alt="Ícono de curso"
            />
            <p
              data-figma-id="238:9865"
              className="cursos-contenido-header-titulo-1-2"
            >
              Todos los cursos
            </p>
            <p
              data-figma-id="238:9866"
              className="cursos-contenido-header-titulo-2-2"
            >
              {totalResultados} cursos
            </p>
          </div>
          <div className="div-block-7">
          <SubEmpaginador
            page={page}
            setPage={setPage}
            totalPages={totalPages}
          />
        </div>
        <div className="filtros-barra-busqueda">
          <SubFilter
            vCategoriesSelected={vCategoriesSelected}
            setVCategoriesSelected={setVCategoriesSelected}
          />
        </div>
        </div>

        <div data-figma-id="238:9874" className="cursos">
          {vCursos.map((vCurso) => (
            <UniversalTarjetaCurso
              vTipoRol="alumno"
              key={vCurso.id}
              vIdCurso={vCurso.id}
              categorias={vCurso.categorias}
              nombreCurso={vCurso.nombre}
              numTotalLecciones={vCurso.total_lecciones}
              numTotalHoras={vCurso.duracion}
              precioCurso={vCurso.precio}
            />
          ))}
        </div>

        <div className="div-block-7-copy">
          <SubEmpaginador
            page={page}
            setPage={setPage}
            totalPages={totalPages}
          />
        </div>
      </div>
    </div>
  );
}
